import React from 'react';
import { CheckCircle, XCircle, X } from 'lucide-react';
import { Button } from './Button';

interface BulkActionsToolbarProps {
  selectedCount: number;
  onBulkApprove: () => void;
  onBulkReject: () => void;
  onClearSelection: () => void;
}

export const BulkActionsToolbar: React.FC<BulkActionsToolbarProps> = ({
  selectedCount,
  onBulkApprove,
  onBulkReject,
  onClearSelection,
}) => {
  if (selectedCount === 0) {
    return null;
  }

  return (
    <div className="sticky top-0 z-10 bg-gradient-to-r from-blue-50 to-blue-100 border border-blue-200 rounded-lg p-4 mb-4 shadow-md animate-slideDown">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-4">
          <div className="flex items-center gap-2">
            <div className="bg-blue-600 text-white rounded-full w-8 h-8 flex items-center justify-center font-semibold text-sm">
              {selectedCount}
            </div>
            <span className="text-gray-700 font-medium">
              {selectedCount === 1 ? '1 request selected' : `${selectedCount} requests selected`}
            </span>
          </div>

          <div className="flex items-center gap-2">
            <Button
              onClick={onBulkApprove}
              className="bg-green-600 hover:bg-green-700 text-white flex items-center gap-2"
            >
              <CheckCircle className="w-4 h-4" />
              Bulk Approve
            </Button>

            <Button
              onClick={onBulkReject}
              className="bg-red-600 hover:bg-red-700 text-white flex items-center gap-2"
            >
              <XCircle className="w-4 h-4" />
              Bulk Reject
            </Button>

            <Button
              onClick={onClearSelection}
              className="bg-gray-500 hover:bg-gray-600 text-white flex items-center gap-2"
            >
              <X className="w-4 h-4" />
              Clear
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
